module.exports = __webpack_public_path__ + "img/Chili Icon - white.ce8c4f8e.svg";